"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var _types_1 = require("../types");
exports.default = (_a = {},
    _a[_types_1.Network.mainnet] = {
        PROXY_ADDRESS: "",
    },
    _a[_types_1.Network.rinkeby] = {
        PROXY_ADDRESS: "",
    },
    _a[_types_1.Network.goerli] = {
        PROXY_ADDRESS: "",
    },
    _a[_types_1.Network.avalanche] = {
        PROXY_ADDRESS: "",
    },
    _a[_types_1.Network.avalancheFuji] = {
        PROXY_ADDRESS: "",
    },
    _a[_types_1.Network.polygon] = {
        PROXY_ADDRESS: "",
    },
    _a[_types_1.Network.mumbai] = {
        PROXY_ADDRESS: "",
    },
    _a[_types_1.Network.binance] = {
        PROXY_ADDRESS: "",
    },
    _a[_types_1.Network.binanceTestnet] = {
        PROXY_ADDRESS: "",
    },
    _a[_types_1.Network.fantom] = {
        PROXY_ADDRESS: "",
    },
    _a[_types_1.Network.fantomTestnet] = {
        PROXY_ADDRESS: "",
    },
    _a[_types_1.Network.scrollL1Testnet] = {
        PROXY_ADDRESS: "",
    },
    _a[_types_1.Network.scrollL2Testnet] = {
        PROXY_ADDRESS: "",
    },
    _a[_types_1.Network.arbitrumOne] = {
        PROXY_ADDRESS: "",
    },
    _a[_types_1.Network.arbitrumGoerli] = {
        PROXY_ADDRESS: "",
    },
    _a);
